module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copybox",
    on: {
      "click": _vm.toBusinessInfo
    }
  }, [_c('img', {
    staticClass: "copyImg",
    attrs: {
      "src": "https://static.dierqudao.com/images/bg-copyright@2x.png"
    }
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copytitlebox"
  }, [_c('span', {
    staticClass: "copytext"
  }, [_vm._v("我也要开店")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4734849e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CopyRight.vue
// module id = 2358
// module chunks = 0